<script lang="ts">
  import VerticalCenter from './verticalCenter.svelte';
  export let loading: boolean;

  let delayedLoading = false;
  let to: number;

  $: {
    if (loading) {
      delayedLoading = loading;
    } else {
      clearTimeout(to);

      to = setTimeout(() => {
        delayedLoading = false;
      }, 300) as any as number;
    }
  }
</script>

<section
  style={loading ? 'opacity: 1; pointer-events: all;' : 'opacity: 0; pointer-events: none;'}
>
  {#if delayedLoading}
    <div />
  {/if}
</section>

<style>
  @keyframes loop_spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  div {
    border: 3px solid var(--loop-accent1, #efefef);
    border-top: 3px solid var(--loop-primary, #000000);
    border-radius: 50%;
    width: 14px;
    height: 14px;
    animation: loop_spin 2s linear infinite;
  }

  section {
    background: var(--loop-background, white);
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
  }
</style>
